import { AppBar, Toolbar, Container, Button, Stack, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Logo } from '../atoms/Logo';

interface HeaderProps {
  onExport: () => void;
}

export const Header = ({ onExport }: HeaderProps) => (
  <AppBar 
    position="sticky" 
    color="inherit" 
    elevation={0} 
    className="no-print"
    sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
  >
    <Container maxWidth="lg">
      <Toolbar disableGutters sx={{ justifyContent: 'space-between', py: 0 }}>
        <Logo />
        {/* <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
          <Typography 
            variant="subtitle2" 
            sx={{ display: { xs: 'none', sm: 'block' }, color: 'secondary.main', fontWeight: 700 }}
          >
            EDICIÓN DÍA DE LA MADRE
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<FileDownloadIcon />}
            onClick={onExport}
            className="no-print"
          >
            Descargar Catálogo
          </Button>
        </Stack> */}
      </Toolbar>
    </Container>
  </AppBar>
);
